import { render, staticRenderFns } from "./AvatarComponent.vue?vue&type=template&id=a8a6122a&scoped=true&"
import script from "./AvatarComponent.vue?vue&type=script&setup=true&lang=js&"
export * from "./AvatarComponent.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AvatarComponent.vue?vue&type=style&index=0&id=a8a6122a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a6122a",
  null
  
)

export default component.exports